/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 公告详情
 */
'use strict';
angular.module("noticeDetailsModule",['noticeDetailsRouter']).
controller('noticeDetailsCtrl', ['$scope','$stateParams','httpService','$sce',function($scope,$stateParams,httpService,$sce){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
        $scope.noticeInfo={};
    };

    function initData(){
		requestData();
    };
    /**
     * [requestData description] 初始化公告的详情
     * @param  {[type]}    [description] 稿件的ID
     * @return {[type]}       [description] null
     */
    $scope.requestData = function(){
    	requestData();
    }
    
    
    function requestData(){
    	 $scope.loadingPromise = httpService.http("/mcnadmin/admin/notice/findById.do", {id:$stateParams.noticeId}, "get").then(function(data) {
           $scope.noticeInfo = data.data;
           $scope.noticeInfo.articleHtmlCon = $sce.trustAsHtml(data.data.noticeContent);
        });
    }
}]);